import React from "react";

// Fin du questionnaire pour un allocataire orienté vers une Mission Locale.
// `url` (lien de préinscription de chaque mission locale) reste non affiché,
// comme avant : décision à prendre avec la Caf.
const LandingML = () => {
  return (
    <div className="etat-final" role="status">
      <span className="etat-final__icone" aria-hidden="true">
        <i className="fa fa-check" />
      </span>
      <div>
        <h2 className="etat-final__titre">Votre questionnaire est terminé</h2>
        <p>
          <strong>Vous serez prochainement contacté(e) par un agent de la Mission Locale</strong> afin de
          prendre rendez-vous avec le professionnel qui vous accompagnera dans vos démarches. La Mission
          Locale est spécialisée dans l'accompagnement des jeunes.
        </p>
        <p>
          <strong>Ce rendez-vous est obligatoire.</strong>
        </p>
      </div>
    </div>
  );
};

export default LandingML;
